import React, { useId } from 'react';

import { Icon } from '@chakra-ui/react';

// Badge circle (bottom-right); used for both the drawn circle and the mask cut.
const BADGE_CIRCLE =
  'M2199 1747C2199 1368.13 2495.39 1061 2861 1061 3226.61 1061 3523 1368.13 3523 1747 3523 2125.87 3226.61 2433 2861 2433 2495.39 2433 2199 2125.87 2199 1747Z';

// Person stroke styling shared by the shoulders and the head.
const personStrokeProps = {
  stroke: 'currentColor',
  strokeWidth: '190.913',
  strokeLinecap: 'round' as const,
  strokeLinejoin: 'round' as const,
  fill: 'none',
  transform: 'matrix(1.03579 0 0 1 1202 56)',
};

export const AuthorizedUserIcon = props => {
  const id = useId();
  const clipId = `${id}-clip`;
  const maskId = `${id}-mask`;

  return (
    <Icon viewBox="0 0 2420 2420" color="inherit" h="full" w="full" {...props}>
      <defs>
        <clipPath id={clipId}>
          <path
            d="M2296 1788C2296 1409.13 2592.39 1102 2958 1102 3323.61 1102 3620 1409.13 3620 1788 3620 2166.87 3323.61 2474 2958 2474 2592.39 2474 2296 2166.87 2296 1788Z"
            fillRule="evenodd"
            clipRule="evenodd"
          />
        </clipPath>

        <mask id={maskId} maskUnits="userSpaceOnUse">
          <rect x="0" y="0" width="4000" height="3000" fill="white" />
          <path d={BADGE_CIRCLE} fill="black" />
        </mask>
      </defs>
      <g transform="translate(-1200 -55)">
        <g mask={`url(#${maskId})`}>
          <path
            d="M1909.17 2004.62 1909.17 1813.71C1909.17 1602.83 1738.21 1431.88 1527.33 1431.88L763.667 1431.88C552.786 1431.88 381.833 1602.83 381.833 1813.71L381.833 2004.62"
            {...personStrokeProps}
          />
        </g>
        <path
          d="M1527.33 668.208C1527.33 879.089 1356.38 1050.04 1145.5 1050.04 934.619 1050.04 763.667 879.089 763.667 668.208 763.667 457.328 934.619 286.375 1145.5 286.375 1356.38 286.375 1527.33 457.328 1527.33 668.208Z"
          {...personStrokeProps}
        />

        <path d={BADGE_CIRCLE} fill="none" />
        <g clipPath={`url(#${clipId})`}>
          <path
            d="M269.855 731.99 505.648 967.772 1032.09 441.333"
            stroke="currentColor"
            strokeWidth="137.917"
            strokeLinecap="round"
            strokeLinejoin="round"
            fill="none"
            transform="matrix(1 0 0 1.03625 2296 1102)"
          />
        </g>
      </g>
    </Icon>
  );
};
